import React from 'react';
import ArrowRight from '../../../visuals/Icons/ArrowRight';
import { IconSizes } from '../../../visuals/Icons/type';
import { HORIZONTAL_BANNER_SIZE } from '../types';

interface IButtonProps extends React.ComponentProps<'button'> {
  size?: HORIZONTAL_BANNER_SIZE;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

export const Button: React.FC<IButtonProps> = ({
  children,
  size = HORIZONTAL_BANNER_SIZE.RESPONSIVE,
  icon,
  ...props
}) => {
  const isResponsive = size === HORIZONTAL_BANNER_SIZE.RESPONSIVE;
  const commonClassnames = `tw-lf-button tw-lf-button-primary group-hover:tw-cursor-pointer group-hover:tw-bg-yellow-400 ${
    isResponsive ? 'desktop:tw-min-w-fit' : ''
  }`;

  return (
    <>
      {isResponsive && (
        <button
          className={`${commonClassnames} tw-lf-button-md tw-hidden desktop:tw-flex`}
          {...props}
        >
          {children}
        </button>
      )}

      <button
        className={`${commonClassnames} tw-h-11 tw-w-11 tw-min-w-[44px] tw-rounded-full tw-p-0 ${
          isResponsive ? 'desktop:tw-hidden' : ''
        }`} // tw-min-w-X not working, must hardcode in pixels
        {...props}
      >
        {icon ?? <ArrowRight size={IconSizes.md} />}
      </button>
    </>
  );
};
